export default "__VITE_ASSET__BEvEfhei__"